import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './index.css';
import { HonestWork } from '@cian/honestwork-component';

interface IProps {
  size: number;
  url?: string;
  hasFairplay?: boolean;
}

export const PhotoMobile = ({ size, url, hasFairplay }: IProps) => (
  <div className={styles['image_wrp']}>
    <Image src={url || ''} width={size} height={size} borderRadius="50%" objectFit="cover" />
    {hasFairplay && (
      <div className={styles['shield']}>
        <HonestWork isPopupDisabled />
      </div>
    )}
  </div>
);
